module.exports = __webpack_public_path__ + "static/media/transferencias.4266baea.svg";